/* BB COLLECTION — inject entries/multiplier pills into Ella cards
   without editing the product-card snippet. Pill data comes from
   sections/bb-collection-style as a JSON script tag keyed by product id.
   v2: observe document.body so AJAX "Show More" / filter / sort appended
   cards get decorated too (the old narrow grid selector missed them). */
(function () {
  'use strict';
  if (!document.body.classList.contains('template-collection')) return;

  var dataEl = document.getElementById('bb-collection-pill-data');
  if (!dataEl) return;

  var PILLS = {};
  try { PILLS = JSON.parse(dataEl.textContent) || {}; } catch (e) { return; }

  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  function buildPills(info) {
    var wrap = document.createElement('div');
    wrap.className = 'bb-card-pills';
    if (info.entries && info.entries > 0) {
      var e = document.createElement('span');
      e.className = 'bb-entries-pill';
      e.innerHTML = '<span class="bb-ticket" aria-hidden="true">\uD83C\uDF9F</span>' + fmt(info.entries) + ' Entries';
      wrap.appendChild(e);
    }
    if (info.mult) {
      var m = document.createElement('span');
      m.className = 'bb-mult-pill';
      m.innerHTML = '<span>' + info.mult + '</span>';
      wrap.appendChild(m);
    }
    return wrap.children.length ? wrap : null;
  }

  function decorate() {
    document.querySelectorAll('.product-item[data-product-id]').forEach(function (card) {
      if (card.querySelector('.bb-card-pills')) return;
      var info = PILLS[card.getAttribute('data-product-id')];
      if (!info) return;
      var pills = buildPills(info);
      if (!pills) return;
      var anchor = card.querySelector('.card-media') || card.querySelector('.card-product__wrapper');
      if (anchor) anchor.appendChild(pills);
    });
  }

  decorate();

  if ('MutationObserver' in window) {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; decorate(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  var scrollPending = false;
  window.addEventListener('scroll', function () {
    if (scrollPending) return;
    scrollPending = true;
    setTimeout(function () { scrollPending = false; decorate(); }, 250);
  }, { passive: true });

  ['halo:updated', 'collection:updated', 'facets:updated', 'ajax:loaded'].forEach(function (evt) {
    document.addEventListener(evt, decorate);
  });
})();